import { styled } from '@mui/material/styles';
import { ListItemButton } from '@sunwisesoftware/sunwise-ui';

const StyledListItemButton = styled(ListItemButton)(
    ({ theme, drawersize, variant }) => ({
        alignItems: 'center',
        display: 'flex',
        flexDirection: variant === 'row',
        justifyContent: 'center',
        padding: variant === 'horizontal' ? '8px' : '8px 16px',
        '& svg': {
            height: '24px',
            width: '24px',
        },
        '& svg path': {
            fill: theme.palette.primary.main,
        },
        '&:hover': {
            borderRadius: '8px',
            '& svg': {
                transform: 'scale(1.14)',
            },
            '& svg path': {
                fill: theme.palette.primary.main,
            },
        },
        '&.Mui-selected, &.Mui-selected:hover': {
            background: '#b9b9bb9a',
            borderRadius: '8px',
            '& svg path': {
                fill: theme.palette.primary.main,
            },
            '& .MuiListItemText-primary': {
                color: theme.palette.primary.main,
            },
        },
        '& .MuiListItemText-root': { margin: 0 },
        [theme.breakpoints.down('md')]: {
            flexDirection: 'row',
            justifyContent: 'left',
            paddingLeft: '16px',
            paddingRight: '16px',
            gap: '8px',
            '& .MuiListItemText-primary': {
                fontSize: '16px',
                textAlign: 'left',
            },
            '&.Mui-selected, &.Mui-selected:hover': {
                background: 'rgba(34, 64, 153, 0.08)',
            },
        },
        ...(drawersize === 'small' && {
            [theme.breakpoints.up('md')]: {
                '& .MuiListItemText-root': { visibility: 'hidden' },
            },
        }),
    }),
);

export default StyledListItemButton;
